import { render, staticRenderFns } from "./buggy_implementations.vue?vue&type=template&id=be9819fe&scoped=true&"
import script from "./buggy_implementations.vue?vue&type=script&lang=ts&"
export * from "./buggy_implementations.vue?vue&type=script&lang=ts&"
import style0 from "./buggy_implementations.vue?vue&type=style&index=0&id=be9819fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9819fe",
  null
  
)

export default component.exports